class ArrayUtil {
    static contains(target: string[], value: string | number, strict: boolean = false): boolean {
        const _value: string =  String(value); 
        const regex = new RegExp(`${strict ? "^" : ""}${_value}${strict ? "$" : ""}`, "gi")
        if (!target) {
            return false;
        }
        for (const item of target) {
            if (String(item).match(regex)?.length) {
                return true;
            }
        }


        return false;
    }

    static addItem<T = any>(list: any[], item: any): T[] {
        const _list: T[] = list;
        _list.push(item)
        return _list;
    }

    static removeItem<T = any>(list: any[], item: any): T[] {
        if (!list) {
            return list;
        }
        const _list: T[] = list?.filter((i) => i !== item) || list;
        return _list;
    }

    static hasSameValues<T = any>(list1: T[], list2: T[]): boolean {
        const l1 = list1.sort();
        const l2 = list2.sort();

        const onlyList1 = l1.filter((item: any) => l2.indexOf(item) === -1);
        const onlyList2 =  l2.filter((item: any) => l1.indexOf(item) === -1);

        if (!onlyList1.length && !onlyList2.length) {
            return true;
        }

        return false;
    }
}

export { ArrayUtil }